<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Recruiters') }}
    </template>
    <template v-if="!recruitersLoadError" #header-actions>
      <AddCompanyRecruiter
        :company-recruiter-ids="companyRecruiterIds"
        :manage-workers="manageWorkers"
        @added="refetch"
      />
    </template>
  </PageHeader>
  <div v-if="recruitersLoadError" class="tw-mt-9">
    <ContentLoadingErrorNotice />
  </div>
  <div v-else>
    <CompanyRecruiterContacts
      :entries="entries"
      :loading="loading"
      :manage-workers="manageWorkers"
      @updated="refetch"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import SilentNetworkError from '@/utils/notification/SilentNetworkError'
import ContentLoadingErrorNotice from '@/components/ContentLoadingErrorNotice.vue'
import CompanyRecruiterContacts from '@/components/Contacts/CompanyRecruiter/CompanyRecruiterContacts.vue'
import AddCompanyRecruiter from '@/components/Contacts/CompanyRecruiter/AddCompanyRecruiter.vue'
import { CompanyRecruiters } from '@/components/Contacts/CompanyRecruiter/queries/CompanyRecruiters'
import { $t } from '@/composables/translation'
import PageHeader from '@/components/PageHeader.vue'

defineProps({
  manageWorkers: {
    type: Boolean,
    default: false,
  },
})

const queryVariables = ref({
  accounts: [currentAccount.globalId],
  perPage: 50,
  page: 1,
})

const recruitersLoadError = ref(false)

const {
  result,
  loading,
  refetch,
  onError: onRecruitersLoadingError,
} = useQuery(CompanyRecruiters, queryVariables, {
  clientId: 'publicApi',
})

onRecruitersLoadingError((error) => {
  recruitersLoadError.value = true

  new SilentNetworkError({
    ex: error,
  }).dispatch()
})

const entries = computed(() =>
  // eslint-disable-next-line @typescript-eslint/no-shadow -- Baseline eslint ignore please fix if working on this
  result.value?.companyRecruiters.data.map((result) => ({
    id: result.recruiter.id,
    avatar: result.recruiter.avatar,
    name: result.recruiter.name,
    status: result.status?.toLowerCase(),
    email: result.email,
    fee: result.recruiterFee * 100,
    ownership: result.recruiterOwnershipDays,
    pivotId: result.id,
    tags: result.tags?.map((appliedTag) => appliedTag.name),
  })),
)

const companyRecruiterIds = computed(
  () => result.value?.companyRecruiters.data.map((contact) => contact.id) ?? [],
)
</script>
